"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildConfigurationText = void 0;
var metricValue_1 = require("../features/metricValue");
var threshold_1 = require("../features/threshold");
var window_1 = require("../features/window");
var comparisonText_1 = require("../formatting/comparisonText");
var dateFormatter_1 = require("../formatting/dateFormatter");
var models_1 = require("../models");
var buildConfigurationText = function (definition, isSingleNumber) {
    var isConstantComparison = (0, threshold_1.isDefaultLineStaticRefLine)(definition);
    var showWindowText = !isSingleNumber;
    var showComparisonText = (isSingleNumber && isConstantComparison) || !isSingleNumber;
    var comparisonText = (0, comparisonText_1.getAuthoredComparisonText)(definition);
    var serverWindow = (0, window_1.getFirstWindow)(definition);
    var windowText = serverWindow && (0, window_1.displayStringFromWindow)(serverWindow);
    if (serverWindow && (0, window_1.isCustomWindow)(serverWindow)) {
        var startDate = serverWindow.range.first;
        var dateTrunc = (0, models_1.dateTruncFromGranularity)((0, metricValue_1.getTimestampGranularity)(definition));
        windowText = (0, dateFormatter_1.dateFormatterFactory)(dateTrunc).configurationInfoStartDate(startDate);
    }
    else if (serverWindow && (0, window_1.isDefinedStartWindow)(serverWindow)) {
        var dateTrunc = (0, models_1.dateTruncFromGranularity)((0, metricValue_1.getTimestampGranularity)(definition));
        windowText = (0, dateFormatter_1.dateFormatterFactory)(dateTrunc).configurationInfoStartDate(serverWindow.startDate);
    }
    return {
        comparisonText: showComparisonText ? comparisonText : undefined,
        windowText: showWindowText ? windowText : undefined,
    };
};
exports.buildConfigurationText = buildConfigurationText;
//# sourceMappingURL=Configuration.js.map